const data = [
  {
    heading: "Bamboo Stand",
    pledge: "Pledge $25 or more",
    description:
      "You get an ergonomic stand made of natural bamboo. You've helped us launch our promotional campaign, and you’ll be added to a special Backer member list.",
  },
  {
    heading: "Black Edition Stand",
    pledge: "Pledge $75 or more",
    description:
      "You get a Black Special Edition computer stand and a personal thank you. You’ll be added to our Backer member list. Shipping is included.",
  },
  {
    heading: "Mahogany Special Edition",
    pledge: "Pledge $200 or more",
    description:
      "You get two Special Edition Mahogany stands, a Backer T-Shirt, and a personal thank you. You’ll be added to our Backer member list. Shipping is included.",
  },
];

export default data;
